<template>
	<common-card :type="cardType" class="omapi-create-campaign-card omapi-welcomebox" v-on="$listeners">
		<div class="omapi-create-campaign">
			<div class="omapi-multi-column__primary">
				<div v-if="$slots.subtitle || subtitle" class="omapi-create-campaign__subtitle">
					<slot name="subtitle">{{ subtitle }}</slot>
				</div>
				<h2 class="omapi-create-campaign__title">
					<slot name="title">{{ title }}</slot>
				</h2>
				<p class="omapi-create-campaign__text">
					<slot />
					<core-button v-if="learnMore" :link-style="true" :arrow="true" @click.prevent="toggleAccordion">
						Learn More
					</core-button>
				</p>
				<core-button
					v-if="!connected"
					size="monster"
					color="green"
					router-to="onboarding-wizard"
					class="omapi-rocket"
				>
					Launch the Setup Wizard
				</core-button>
				<core-button v-else-if="!hideButton" :arrow="true" size="monster" color="green" router-to="templates">
					Create a Campaign
				</core-button>
				<slot name="afterButtons">{{ afterButtons }}</slot>
			</div>
			<a
				:href="videoSrc"
				class="omapi-multi-column__secondary omapi-create-campaign__video"
				@click.prevent="triggerVideo"
			>
				<img src="../../assets/images/video-preview.jpg" alt="Click to Watch Video" />
			</a>
		</div>
		<common-modal-welcome-video :src="videoSrc" />
		<template #footer>
			<common-transition-slide :active="accordionOpen">
				<hr />
				<section class="learn-more-content">
					<common-welcome-om-effect />
					<common-welcome-top-reasons />
					<core-create-connect class="omapi-connect" />
					<common-welcome-featured-in />
					<common-welcome-testimonials />
					<section class="omapi-join-thousands">
						<p>
							Join the thousands of users who use OptinMonster to convert abandoning website visitors into
							subscribers and customers.
						</p>
						<core-create-connect />
					</section>
				</section>
			</common-transition-slide>
		</template>
	</common-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		cardType: {
			type: String,
			default: 'permanent',
		},
		subtitle: {
			type: String,
			default: 'Getting Started',
		},
		title: {
			type: String,
			default: 'Welcome to OptinMonster',
		},
		videoSrc: {
			type: String,
			default: 'https://www.youtube.com/embed/jbP9C9bQtv4?rel=0&controls=0&showinfo=0&autoplay=1',
		},
		afterButtons: {
			type: String,
			default: '',
		},
		learnMore: Boolean,
		hideButton: Boolean,
	},
	data() {
		return {
			accordionOpen: Boolean(this.$get('$store.state.queryArgs.info')),
		};
	},
	computed: {
		...mapGetters(['connected']),
	},
	methods: {
		triggerVideo() {
			this.$modal.show('welcome-video');
		},
		toggleAccordion() {
			this.accordionOpen = !this.accordionOpen;
		},
	},
};
</script>

<style lang="scss">
@import '../../assets/scss/components/welcomebox';

.omapi-welcomebox {
	.omapi-card-footer {
		padding-left: 40px;
		padding-right: 40px;

		.learn-more-content {
			width: 100%;

			.omapi-connect {
				display: flex;
				justify-content: center;
				margin: 60px 0;

				&.omapi-no-connection-buttons {
					span {
						display: flex;
						align-items: center;
					}
				}
			}

			.omapi-join-thousands {
				text-align: center;
				margin: 60px auto;
				width: 60%;
				@media screen and (max-width: 1005px) {
					width: 89%;
				}
			}
		}
	}

	hr {
		margin: 40px 0 60px 0;
	}
}
</style>
